
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/do-i-have-a-case",
      function () {
        return require("private-next-pages/do-i-have-a-case.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/do-i-have-a-case"])
      });
    }
  